import React from "react";

type Props = {
  setSelectedType: React.Dispatch<React.SetStateAction<string>>;
  selectedType: string;
};

const TabType = ({ setSelectedType, selectedType }: Props) => {
  const data = [
    {
      label: "Escuelas",
      value: "escuela",
    },
    {
      label: "Instructores",
      value: "instructor",
    },
  ];

  return (
    <div id='search' className="result_search relative z-[100] mx-auto max-w-xl flex justify-center items-center py-20">
      <div className="flex rounded-lg bg-gray-100 p-1 w-full shadow-lg border-.5">
        {data.map(({ label, value }) => (
          <button
            key={value}
            className={`flex-1 px-4 py-3 font-bold text-lg rounded-md transition-colors
              ${
                selectedType === value
                  ? "!bg-gradient-to-tr !from-blue-500 !via-blue-500 !to-blue-300 text-white"
                  : "text-gray-700 hover:bg-gray-200"
              }`}
            onClick={() => setSelectedType(value)}
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default TabType;
